if(!customElements.get('menu-drawer')){
    class MenuDrawer extends HTMLElement {
        constructor(){
            super();
        }

        connectedCallback(){
            // menu drawer or mobile menu drawer
            if(this.id == 'menu-drawer'){
                this.buttonMenuDrawer = document.getElementById('button-menu-drawer');
            }else if(this.id == 'mobile-menu-drawer'){
                this.buttonMenuDrawer = document.getElementById('button-mobile-menu-drawer'); 
            }

            if(!this.buttonMenuDrawer) return;

            this.drawerMenus = this.querySelectorAll('a');

            this.buttonMenuDrawer.addEventListener('click', (e) => { 
                e.preventDefault();
                this.onButtonMenuDrawerClick();
            });
            this.buttonMenuDrawer.addEventListener('keydown', e => {
                if(e.key === 'Enter'){
                    e.preventDefault();
                    const isKeyboard = true;
                    this.onButtonMenuDrawerClick(isKeyboard);
                }
            });
            
            // close drawer
            this.addEventListener('click', this.onDrawerClick.bind(this));
            this.querySelectorAll('[data-close]').forEach(item => {
                item.addEventListener('click', this.closeDrawer.bind(this));
                item.addEventListener('keydown', e => {
                    if(e.key === 'Enter') this.closeDrawer();
                });
            });
            this.addEventListener('keyup', e => {
                if(e.code && e.code.toUpperCase() === 'ESCAPE'){
                    this.closeDrawer();
                }
            });

            // click on submenu
            this.querySelectorAll('[data-link-handler]').forEach(item => {
                item.addEventListener('click', this.onLinkHandlerClick.bind(this));
                item.addEventListener('focus', e => {
                    item.classList.remove('no-keyboard-focus');
                    item.addEventListener('blur', e => {
                        item.classList.add('no-keyboard-focus');
                    }, { once: true });
                });
            });
            
            this.querySelectorAll('a:not([data-link-handler])').forEach(item => {
                item.addEventListener('focus', e => {
                    item.classList.remove('no-keyboard-focus');
                    item.addEventListener('blur', e => {
                        item.classList.add('no-keyboard-focus');
                    }, { once: true });
                });
            });

            window.addEventListener('resize', this.closeDrawer.bind(this));

            this.buttonCountries = this.querySelectorAll(".button--country");
            this.buttonCountries.forEach(item => {
                item.addEventListener("click", e => {
                    this.onLocalizationOptionClick(e, 'menu-drawer-currency-form');
                });
                item.addEventListener("keydown", e => {
                    if(e.key === 'Enter'){
                        this.onLocalizationOptionClick(e, 'menu-drawer-currency-form');
                    }
                });
            });

            this.buttonLanguages = this.querySelectorAll(".button--language");
            this.buttonLanguages.forEach(item => {
                item.addEventListener("click", e => {
                    this.onLocalizationOptionClick(e, 'menu-drawer-language-form');
                });
                item.addEventListener("keydown", e => {
                    if(e.key === 'Enter'){
                        this.onLocalizationOptionClick(e, 'menu-drawer-language-form');
                    }
                })
            });

            // initialize collection swipers
            this.initializeSwipers();
        }

        onButtonMenuDrawerClick(isKeyboard = false){
            this.previouslyFocusedElement = document.activeElement;

            const isOpening = this.getAttribute('aria-hidden') === 'true';
            this.setAttribute('aria-hidden', isOpening ? 'false' : 'true');

            if(isOpening){
                this.removeAttribute('inert');
                document.body.style.overflow = 'hidden';
                document.documentElement.style.overflow = 'hidden';

                FocusTrap.activate(this);
            }else{
                this.closeDrawer();
                return;
            }

            // give focus to drawer
            if(this.drawerMenus.length > 0){
                if(isKeyboard){
                    this.drawerMenus[0].classList.remove('no-keyboard-focus');
                }else{
                    this.drawerMenus[0].classList.add('no-keyboard-focus');
                }

                setTimeout(() => {
                    this.drawerMenus[0].focus();
                }, 300);
            }
        }

        onDrawerClick(e){
            const isDrawerClicked = e.target === e.currentTarget;
            if(isDrawerClicked){
                this.closeDrawer();
            }
        }

        closeDrawer(){
            FocusTrap.deactivate(this);

            this.setAttribute('aria-hidden', 'true');
            this.setAttribute('inert', '');
            this.buttonMenuDrawer.classList.remove('active');

            document.body.style.overflow = '';
            document.documentElement.style.overflow = '';

            const targetMenu = this.querySelector(`.menu--drawer[data-link-handle="-1"]`);
            if(targetMenu){
                this.querySelectorAll('.menu--drawer').forEach(item => {
                    item.classList.add('hidden');
                });
                targetMenu.classList.remove('hidden');
            }

            if(this.previouslyFocusedElement){
                this.previouslyFocusedElement.focus();
            }
        }

        onLinkHandlerClick(e){
            e.preventDefault();
            var linkId = e.currentTarget.dataset.linkHandle;

            if(linkId){
                const targetMenu = this.querySelector(`.menu--drawer[data-link-handle="${linkId}"]`);

                this.querySelectorAll('.menu--drawer').forEach(item => {
                    item.classList.add('hidden');
                });

                targetMenu.classList.remove('hidden');
                const targetMenuLinks = targetMenu.querySelectorAll('a');
                if(targetMenuLinks.length > 0){
                    targetMenuLinks[0].focus();
                }
            }
        }

        onLocalizationOptionClick(e, formId){
            e.preventDefault();
            const option = e.currentTarget;
            const form = this.querySelector(`#${formId}`);
            const input = form? form.querySelector('.input-locale') : null;
            if(input && form){
                input.value = option.dataset.value;
                form.submit();
            }
        }

        async initializeSwipers(){
            this.swiperContainers = this.querySelectorAll('.swiper-container');
            if(this.swiperContainers.length === 0) return;

            if(typeof Swiper === 'undefined'){
                await new Promise(resolve => {
                    const check = () => {
                        if(typeof Swiper !== 'undefined') resolve();
                        else requestAnimationFrame(check);
                    };
                    check();
                });
            }

            this.swiperContainers.forEach(swiperContainer => {
                var swiperSettings = {
                    init: false,
                    initialSlide: 0,
                    loop: false,
                    centeredSlides: false,
                    speed: 500,
                    watchOverflow: true,
                    slidesPerView: 1,
                    observer: true,
                    observeSlideChildren: true,
                    autoHeight: false,
                    spaceBetween: 30
                }

                const swiper = new Swiper(swiperContainer, swiperSettings);
                swiper.init();

                // Mark clone slides as inert so keyboard focus skips duplicates
                swiper.slides.forEach(slide => {
                    if(slide.classList.contains('swiper-slide-duplicate')){
                        slide.setAttribute('inert', '');
                        slide.setAttribute('aria-hidden', 'true');
                    }
                });

                // Re-apply inert to clones after Swiper updates (loop mode re-creates clones)
                swiper.on("slideChange", () => {
                    swiper.slides.forEach(slide => {
                        if(slide.classList.contains('swiper-slide-duplicate')){
                            slide.setAttribute('inert', '');
                            slide.setAttribute('aria-hidden', 'true');
                        }
                    });
                });
            });

            this.setupFocusListeners();
        }

        setupFocusListeners(){
            this.querySelectorAll(".button-next, .button-previous").forEach(button => {
                button.addEventListener('focus', () => {
                    button.classList.add('focused');
                    button.addEventListener('blur', () => {
                        button.classList.remove('focused');
                    }, { once: true });
                });
            });
        }
    }

    customElements.define('menu-drawer', MenuDrawer);
}